export enum Protocol {
    Nok = 'nok-protocol',
    Ak = 'ak-protocol',
    Soviet = 'soviet-protocol',
}
